export default function StarIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={className}
        d="M16.0155 4.01788L18.0686 8.15803C18.3486 8.73435 19.0951 9.28715 19.7251 9.39301L23.4463 10.0164C25.8261 10.4163 26.3861 12.157 24.6712 13.8743L21.7782 16.7912C21.2882 17.2851 21.02 18.2378 21.1715 18.9201L21.9999 22.5309C22.6531 25.389 21.1482 26.4947 18.6402 25.0009L15.1522 22.9191C14.5224 22.5427 13.4841 22.5427 12.8425 22.9191L9.35457 25.0009C6.85817 26.4947 5.34168 25.3772 5.99494 22.5309L6.82318 18.9201C6.97482 18.2378 6.70652 17.2851 6.21657 16.7912L3.32356 13.8743C1.62042 12.157 2.16869 10.4163 4.54842 10.0164L8.26968 9.39301C8.88795 9.28715 9.63453 8.73435 9.9145 8.15803L11.9676 4.01788C13.0875 1.77138 14.9072 1.77138 16.0155 4.01788Z"
        stroke="#455468"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
